import type { InferEntity } from '@mikro-orm/core';
import type { account_schema } from './schema';

export const RETURN_URL_KEY = 'returnUrl';
export const SOCIAL_SIGNUP_PROFILE_COOKIE_NAME = 'social_signup';


export type Account = InferEntity<typeof account_schema>;
